import renderBr from './render';
import deserializeBr from './deserialize';

const BrPlugin = options => ({
  renderElement: renderBr(options),
  deserialize: deserializeBr(options),
});

export default BrPlugin;
